var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle4, _ellipse, _circle5, _path10, _path11, _circle6, _ellipse2, _circle7, _path12, _path13, _path14, _path15, _path16, _circle8, _path17, _path18, _circle9, _path19, _rect, _rect2, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: "30vh",
    viewBox: "0 0 780.99866 659.07566",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M989.58289,211.98157H358.15711a.91644.91644,0,1,1,0-1.83287H989.58289a.91644.91644,0,1,1,0,1.83287Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.28352,
    cy: 68.60845,
    r: 10.08082,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.10816,
    cy: 68.60845,
    r: 10.08082,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.9328,
    cy: 68.60845,
    r: 10.08082,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M968.71769,185.15592H943.97387a1.83288,1.83288,0,0,1,0-3.66576h24.74382a1.83288,1.83288,0,1,1,0,3.66576Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M968.71769,192.0292H943.97387a1.83288,1.83288,0,1,1,0-3.66575h24.74382a1.83288,1.83288,0,1,1,0,3.66575Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M968.71769,198.90249H943.97387a1.83288,1.83288,0,0,1,0-3.66576h24.74382a1.83288,1.83288,0,1,1,0,3.66576Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M545.01942,492.48315a1.29539,1.29539,0,0,0-1.294,1.294V662.92758a1.29524,1.29524,0,0,0,1.294,1.294H780.67383a1.29525,1.29525,0,0,0,1.294-1.294V493.77713a1.29541,1.29541,0,0,0-1.294-1.294Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#e4e4e4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M767.66626,506.447V626.64892a3.03267,3.03267,0,0,1-3.0284,3.02867H560.578c-.14789,0-.29505-.01479-.44293-.02958a3.036,3.036,0,0,1-2.58547-2.99909V506.447a3.03267,3.03267,0,0,1,3.0284-3.02866H764.63786A3.0232,3.0232,0,0,1,767.66626,506.447Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.51214,285.48315a1.29539,1.29539,0,0,0-1.294,1.294V455.92758a1.29523,1.29523,0,0,0,1.294,1.294H781.16655a1.29525,1.29525,0,0,0,1.294-1.294V286.77713a1.29541,1.29541,0,0,0-1.294-1.294Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M768.159,299.447V419.64892a3.03267,3.03267,0,0,1-3.0284,3.02867H561.07075c-.14788,0-.295-.01479-.44293-.02958a3.036,3.036,0,0,1-2.58547-2.99909V299.447a3.03268,3.03268,0,0,1,3.0284-3.02866H765.13059A3.0232,3.0232,0,0,1,768.159,299.447Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M768.159,389.40632v30.2426a3.03267,3.03267,0,0,1-3.0284,3.02867H561.07075c-.14788,0-.295-.01479-.44293-.02958a3.036,3.036,0,0,1-2.58547-2.99909V371.86949l.01443-.0147.57639-3.339c1.52214-7.66775,10.31229-12.0557,18.11269-11.47949,7.80112.57621,14.80438,4.7573,21.5703,8.67238,6.76665,3.93,14.03538,7.80076,21.85093,7.653,15.91172-.29549,27.64226-16.78333,43.49482-18.30511,24.77617-2.39339,41.22028,31.74959,66.07,30.50852,10.69606-.53184,21.68861-7.7416,31.33577-3.11731A15.91608,15.91608,0,0,1,768.159,389.40632Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#f0f0f0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.45268,
    cy: 165.81159,
    r: 51.01449,
    fill: "#6c63ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.26427,
    cy: 72.18841,
    rx: 72.2029,
    ry: 72.18841,
    fill: "#6c63ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.48166,
    cy: 135.2029,
    r: 51.01449,
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M628.26593,425.24121a.93081.93081,0,0,0,.92041-.79965c.03954-.27787,3.91321-28.21526.43422-65.34522-3.21287-34.29041-13.53069-83.68067-44.43884-124.24409a.93089.93089,0,1,0-1.48083,1.12843c30.64119,40.21314,40.87583,89.241,44.06605,123.28929,3.45877,36.91391-.38453,64.63343-.42377,64.90918a.93161.93161,0,0,0,.92276,1.06206Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M612.815,288.48835a.93085.93085,0,0,0,.548-1.68385,128.29612,128.29612,0,0,0-28.32321-14.41807c-15.62641-5.72092-39.38871-10.90733-63.85158-3.12166a.93076.93076,0,1,0,.56452,1.77385c23.96168-7.62568,47.29324-2.525,62.64694,3.09621a126.18873,126.18873,0,0,1,27.86884,14.17565A.92715.92715,0,0,0,612.815,288.48835Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.09036,
    cy: 210.23589,
    r: 33.62319,
    fill: "#e4e4e4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 526.69181,
    cy: 148.5297,
    rx: 47.58827,
    ry: 47.57872,
    fill: "#e4e4e4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 558.84398,
    cy: 190.06197,
    r: 33.62319,
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M714.77136,422.29024a.61348.61348,0,0,1-.60663-.527,205.41554,205.41554,0,0,1-.28619-43.06844c2.11757-22.60049,8.91795-55.15316,29.28924-81.88815a.61354.61354,0,1,1,.976.74374c-20.19533,26.50412-26.94089,58.81793-29.04354,81.25885a204.02616,204.02616,0,0,0,.2793,42.781.614.614,0,0,1-.60818.7Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M724.95491,332.15767a.61352.61352,0,0,1-.36119-1.10981,84.55925,84.55925,0,0,1,18.66757-9.50282c10.29923-3.77061,25.96074-7.18892,42.084-2.05746a.61345.61345,0,1,1-.37207,1.16913c-15.79293-5.026-31.17055-1.66422-41.29,2.04069a83.17,83.17,0,0,0-18.3681,9.343A.61106.61106,0,0,1,724.95491,332.15767Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M764.63776,630.6775H662.77521V565.16383H768.66632v61.48486A4.03308,4.03308,0,0,1,764.63776,630.6775Zm-99.86255-2h99.86255a2.03094,2.03094,0,0,0,2.02856-2.02881V567.16383H664.77521Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M764.63776,630.6775H684.93634V582.89284h83.73v43.75585A4.03308,4.03308,0,0,1,764.63776,630.6775Zm-77.70142-2h77.70142a2.03094,2.03094,0,0,0,2.02856-2.02881V584.89284h-79.73Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#e4e4e4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M764.63776,630.6775H710.05231V602.09889h58.614v24.5498A4.03308,4.03308,0,0,1,764.63776,630.6775Zm-52.58545-2h52.58545a2.03094,2.03094,0,0,0,2.02856-2.02881v-22.5498h-54.614Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#e4e4e4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.7715,
    cy: 425.01792,
    r: 23.63854,
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M345.3266,778.71168H332.51727a6.14815,6.14815,0,0,1-6.14123-6.14111V665.80983a6.14816,6.14816,0,0,1,6.14123-6.14112H345.3266a6.14817,6.14817,0,0,1,6.14124,6.14112V772.57057A6.14816,6.14816,0,0,1,345.3266,778.71168Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.91644,778.71168H301.10687a6.14815,6.14815,0,0,1-6.14123-6.14111V665.80983a6.14816,6.14816,0,0,1,6.14123-6.14112h12.80957a6.14807,6.14807,0,0,1,6.14112,6.14112V772.57057A6.14806,6.14806,0,0,1,313.91644,778.71168Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#6c63ff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.3836,
    cy: 353.89537,
    r: 51,
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M346.50816,491.28461c3.22545-.73067,7.23961-1.64053,9.90052-4.52629a8.13271,8.13271,0,0,0,1.96264-6.57775,5.47084,5.47084,0,0,0-2.69577-4.04749c-1.89522-1.05162-4.33047-.90506-6.738.35089l-1.17436-19.87474-1.9965.11762,1.38068,23.36529,1.47616-1.06553c1.71147-1.23494,4.20809-2.18449,6.08139-1.145a3.51513,3.51513,0,0,1,1.692,2.61725,6.14689,6.14689,0,0,1-1.45868,4.90345c-2.07078,2.24559-5.24312,3.10912-8.87206,3.93194Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 357.79803,
    y: 455.31665,
    width: 10.77161,
    height: 2,
    transform: "translate(-291.0415 -41.435) rotate(-11.17345)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 324.4425,
    y: 461.90517,
    width: 10.77161,
    height: 2,
    transform: "translate(-292.95048 -47.77374) rotate(-11.17345)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M339.42841,684.96217H279.96784a6.50744,6.50744,0,0,1-6.5-6.5V589.23366a51.32975,51.32975,0,0,1,51.2716-51.27149h46.2284a6.50745,6.50745,0,0,1,6.5,6.5V646.92262A38.08259,38.08259,0,0,1,339.42841,684.96217Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M333.53864,669.05836l-.0011-.02148a5.76213,5.76213,0,0,1-5.54639-5.45313l-4.85974-93.37548a11.72391,11.72391,0,0,1,23.28162-2.4795,11.91659,11.91659,0,0,1,.13281,1.26075l4.85962,93.37548a5.7561,5.7561,0,0,1-5.44885,6.04737Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32319,451.90484c1.64637-4.93556,7.36508-6.83949,12.12225-6.98738,6.68727-.20789,13.21617,2.16694,19.92434,1.10555,12.16881-1.92538,19.76528-13.6531,22.133-24.88024,1.57921-7.48829,1.43928-15.16474,1.261-22.774a1.52372,1.52372,0,0,0-2.49-1.23486,24.362,24.362,0,0,0-9.84571,13.98866l2.91363.60266,1.53241-13.29036a1.5202,1.5202,0,0,0-1.00453-1.52828c-4.56449-1.58984-8.36971,1.998-10.85331,5.39229-1.28619,1.75781-2.52026,3.673-4.43146,4.8175a10.96348,10.96348,0,0,1-6.52138,1.263c-4.65-.33615-9.05866-2.09325-13.614-2.96314a49.60024,49.60024,0,0,0-12.69316-.7057,53.369,53.369,0,0,0-23.75488,7.49473c-7.20814,4.34318-13.80716,10.55037-17.63277,18.12886-2.18422,4.3269-3.37009,9.3073-2.17023,14.10342a14.27921,14.27921,0,0,0,8.11359,9.96069c1.78577.74761,2.75721-2.09216.98349-2.83472a11.27266,11.27266,0,0,1-6.27308-8.22325c-.85771-3.99124.19244-8.12082,2.02108-11.69538,3.56116-6.96121,9.65672-12.75011,16.3009-16.75615a51.26781,51.26781,0,0,1,22.2467-7.17973,47.04049,47.04049,0,0,1,11.53051.50208c4.27228.712,8.35919,2.241,12.641,2.91612,4.699.74088,9.57521.08923,12.93812-3.56735,2.47348-2.68946,5.52975-9.4401,10.18538-7.81851l-1.00453-1.52828-1.53242,13.29036c-.19173,1.66289,2.484,2.26417,2.91364.60265a21.88513,21.88513,0,0,1,8.99842-12.72424l-2.49-1.23486c.29565,12.617.56038,26.56172-7.84936,36.90045a21.40809,21.40809,0,0,1-14.455,8.1971c-6.5.58247-12.8811-1.77057-19.38958-1.22715-5.628.4699-11.683,3.19082-13.58881,8.904a1.50112,1.50112,0,0,0,2.83472.98348Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M857.98537,779.53783h-647.294a1.19069,1.19069,0,0,1,0-2.38137h647.294a1.19069,1.19069,0,0,1,0,2.38137Z",
    transform: "translate(-209.50067 -120.46217)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineGallery);
export default __webpack_public_path__ + "static/media/online-gallery.b2412fcf1c2cbc7832394a77707b4b9a.svg";
export { ForwardRef as ReactComponent };